import { Box } from '@mui/material';
import type { StructuredContentDocument } from '@repo/supergraph-schemas/structuredContent/types';
import { StructuredContentRenderer } from '../..';

export type ListProps = StructuredContentDocument<{
  ordered?: boolean;
  children: StructuredContentDocument;
}>;

export const List = ({ props }: ListProps) => {
  const ordered = props.ordered === true;

  return (
    <Box
      component={ordered ? 'ol' : 'ul'}
      role="list"
      sx={{ paddingLeft: 0, ...(ordered && { counterReset: 'list-item' }) }}
    >
      <StructuredContentRenderer doc={props.children} />
    </Box>
  );
};
